/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function hasFiles(list: FileList): boolean {
  return list.length > 0;
}
